<template>
  <div class="register">
    <div class="box">
      <div class="box-text">
        <span>{{ $t('main.passwordFinding') }}</span>
      </div>
      <el-form
          :model="formData"
          :rules="rules"
          ref="formData"
          label-position="right"
          label-width="120px"
          class="demo-ruleForm"
      >
        <el-form-item
            v-if="!isCN"
            class="is-required"
            :label="$t('main.emailAccount')+':'"
            prop="email"
        >
          <el-input
              v-model="formData.email"
              :placeholder="$t('main.enterMail')"
          ></el-input>
        </el-form-item>
        <!-- 手机号 -->
        <el-form-item class="is-required" v-if="isCN" :label="$t('main.telephoneAccount')" prop="phone">
          <el-input
              v-model="formData.phone"
              :placeholder="$t('main.enterTelephone')"
          ></el-input>
        </el-form-item>
        <!-- 非中文用户注册时，验证的邮箱 -->
        <el-form-item class="is-required" :label="$t('main.loginCode')+':'">
          <el-col :span="15">
            <el-input
                v-model="formData.captcha"
                :placeholder="$t('main.pleaseEnterYourLoginCode')"
            ></el-input>
          </el-col>
          <el-col :span="5">
            <el-button
                @click="sendCode"
                class="sendCode"
                :disabled="countdown > 0"
            >
              <div v-if="countdown > 0">{{ countdown }} s</div>
              <div v-else>{{ $t('main.sendLoginCode') }}</div>
            </el-button>
          </el-col>
        </el-form-item>

        <el-form-item class="is-required" :label="$t('main.password')+':'" prop="password">
          <el-input
              v-model="formData.password"
              :placeholder="$t('main.pleaseEnterYourPassword')"
              show-password
          ></el-input>
        </el-form-item>
        <el-form-item class="is-required" :label="$t('main.retypePassword')+':'" prop="confirmPsw">
          <el-input
              show-password
              v-model="formData.confirmPsw"
              :placeholder="$t('main.PleaseConfirmYourPassword')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button class="loginBtn" @click="findPsw">{{ $t('main.commit') }}</el-button>
        <div class="right">
          {{ $t('main.hasAccount') }}<span class="gzc" @click="goLink('/login')"> {{ $t('main.login') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  sendSMS,
  sendEmail,
  findPsd
} from '@/api/index'
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      formData: {
        xing: '',
        ming: '',
        email: '',
        password: '',
        confirmPsw: '',
        phone: '',
        captcha: '',
      },
      rules: {
        name: [
          // { required: true, message: "请输入活动名称", trigger: "blur" },
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
      },
      checked: false, //只有在cheked为true的时候才可以提交
      isCN: false, // 判断当前是中文还是英文
      countdown: 0, //
      serverHttp: "" // 服务条款跳转链接
    }
  },
  watch: {
    "$store.state.siteInfo": function(newV) {
      if (newV) {
        this.isCN = this.$i18n.locale === "zn";
      }
    }
  },
  created() {
    this.userLanguage()
  },
  methods: {
    // 判断是否中文及服务条款跳转链接
    userLanguage() {
      this.isCN = this.$i18n.locale === "zn";
    },
    goLink(url) {
      this.$router.push(url)
    },
    // 找回密码
    findPsw() {
      this.changePassword()
    },
    // 修改密码
    changePassword() {
      // 如果是忘记密码走找回密码接口，否则走修改密码接口
      let params = {
        req: {
          username: this.formData.phone || this.formData.email,
          captcha: this.formData.captcha,
          info: {
            new_psd: this.formData.password,
            new_confirm_psd: this.formData.confirmPsw,
          }
        },
      }
      findPsd(params).then((res) => {
        if (res.rsp.code === 0) {
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: "success"
          })
          this.goLink('/login')
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error',
          })
        }
      })
    },

    startCountdown() {
      if (this.countdown > 0) {
        this.countdown--;
        setTimeout(() => {
          this.startCountdown();
        }, 1000);
      }
    },
    //发送验证码
    sendCode() {
      // console.log('发送验证码')
      let data = {}
      if (this.isCN) {
        data = {
          req: {
            telephone: this.formData.phone,
          },
        }
        sendSMS(data).then((res) => {
          if (res.rsp.code === 0) {
            this.$message({
              message: this.$t('main.operationCompletedSuccessfully'),
              type: "success"
            })
            this.countdown = 60;
            this.startCountdown();
          } else {
            this.$message({
              message: res.rsp.msg,
              type: 'error',
            })
          }
        })
      } else {
        data = {
          req: {
            email: this.formData.email,
          },
        }
        sendEmail(data).then((res) => {
          if (res.rsp.code === 0) {
            this.$message({
              message: this.$t('main.operationCompletedSuccessfully'),
              type: "success"
            })
          } else {
            this.$message({
              message: res.rsp.msg,
              type: 'error',
            })
          }
        })
      }
    },
  },
}
</script>

<style scoped lang="less">
.register {
  text-align: center;
  .box {
    width: 500px;
    padding: 3rem;
    margin: 3.25rem auto;
    border: 1px solid #f5f5f5;
    border-radius: 1rem;
    .box-text {
      font-size: 1.875rem;
      line-height: 1.875rem;
      font-family: YouSheBiaoTiHei,serif;
      font-weight: bold;
      color: #1a1a1a;
      padding-bottom: 3rem;

      span {
        position: relative;
        padding: 0 15px;
        background: #fff;
      }
    }

    .box-text:before {
      content: '';
      display: block;
      position: relative;
      width: 100%;
      height: 1px;
      top: 1rem;
      background: #f5f5f5;
    }
    .leftcheck {
      margin: 1.875rem 0 3.75rem;
      text-align: left;
    }
    .loginBtn {
      width: 100%;
      height: 3rem;
      background: #635796;
      border-radius: 2rem;
      font-weight: 500;
      color: #ffffff;
    }
    .right {
      padding-top: 1.875rem;
      text-align: right;
    }
    /deep/ .el-form-item {
      border: 1px solid #e5e5e5;
      border-radius: 4px;

      .sendCode {
        height: 3.75rem;
        position: absolute;
        border: 0;
        right: 0;
        float: right;
        color: #1a1a1a;
        border-radius: 0.5rem;
      }
      .sendCode:hover {
        background: none;
      }
      .sendCode:focus {
        background: none;
      }
    }
    /deep/ .el-button {
      padding: 12px 5px;
    }
    /deep/ .el-input__inner {
      border: 0px solid #dcdfe6;
    }
    /deep/ .el-form-item__label {
      height: 3.75rem;
      line-height: 3.75rem;
      background-color: #fff;
      color: #1a1a1a;
      border: 0;
      font-weight: 600;
      border-radius: 0.5rem;
    }
  }
  .gzc {
    color: #635796;
    cursor: pointer;
  }
  ::v-deep .el-input__inner {
    height: 3.75rem;
  }
  .input-icon {
    height: 44px;
    width: 14px;
    margin-left: 2px;
  }
  /deep/.el-input-group__prepend {}
}
</style>